export function truncateToOneDecimalWithoutRounding(value: any) {
    const num = value.toString();
    const idx = num.indexOf('.');
    if (idx > -1) {
        return Number(num.slice(0, idx + 2));
    } else {
        return Number(value);
    }
}
